import styled from "@emotion/styled"
import CustomLink from "../custom-link/custom-link.component"
import { Typography } from "@mui/material"
import { css } from "@emotion/react"

export const Wrapper = styled.footer`
  color: white;
  padding-top: 2.5rem;
  padding-bottom: 1.25rem;
  background: #131314;
  ${({ theme }) => theme.breakpoints.up("sm")} {
    padding-top: ${({ theme }) => theme.typography.pxToRem("60")};
    padding-bottom: 1.5rem;
  }
  .MuiStack-root {
    transition: all 1.5s ease;
  }
`

export const LogoWrapper = styled(CustomLink)`
  display: flex;
  svg {
    width: 100px;
    height: auto;
    ${({ theme }) => theme.breakpoints.up("lg")} {
      width: 116px;
    }
  }
`

export const Content = styled(Typography)`
  color: ${({ theme }) => theme.palette.text.light};
  font-size: 0.875rem;
  line-height: ${({ theme }) => theme.typography.pxToRem("22")};
  margin-top: 1.5rem;
  opacity: 0.65;
  margin-bottom: 0.75rem;
  ${({ theme }) => theme.breakpoints.up("sm")} {
    margin-top: 2.25rem;
  }
  ${({ theme }) => theme.breakpoints.up("md")} {
    max-width: 440px;
  }
`

export const GroupTitle = styled(Typography)`
  color: ${({ theme }) => theme.palette.text.light};
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-weight: 700;
  line-height: normal;
  text-transform: uppercase;
  opacity: 0.4;
  margin-bottom: 0.5rem;
  ${({ theme }) => theme.breakpoints.up("sm")} {
    margin-bottom: 1.5rem;
  }
`

const TextStyled = ({ theme }) => css`
  color: ${theme.palette.text.light};
  font-size: 0.875rem;
  line-height: 1.5rem;
  opacity: 0.75;
  svg {
    transition: all 0.2s ease-in-out;
  }
  &.bottom {
    color: ${theme.palette.secondary.light};
    text-decoration-line: underline;
    opacity: 0.4;
  }
  &.center {
    display: flex;
    align-items: center;
    gap: 0.25rem;
  }
  &.open {
    svg {
      transform: rotate(180deg);
    }
  }
`

export const StyledLink = styled(CustomLink)`
  ${TextStyled}
`

export const StyledText = styled(Typography)`
  ${TextStyled}
  cursor: pointer;
  &.bottom {
    text-decoration: none;
  }
`

export const BottomWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem 2.5rem;
  margin-top: 2.25rem;
  flex-wrap: wrap;
  ${({ theme }) => theme.breakpoints.up("sm")} {
    margin-top: 5.25rem;
    column-gap: 3.25rem;
  }
`
